// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7c18e607","455":"f60ef196"}[chunkId] + ".chunk.js";
};